import { render, staticRenderFns } from "./templatePill.vue?vue&type=template&id=a5982e08&scoped=true&"
import script from "./templatePill.vue?vue&type=script&lang=js&"
export * from "./templatePill.vue?vue&type=script&lang=js&"
import style0 from "./templatePill.vue?vue&type=style&index=0&id=a5982e08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5982e08",
  null
  
)

export default component.exports